/*
 * /document-signer — ядро вкладки «Подписать».  window.DS
 *
 * Строки, форматирование, хранилище ключа и сертификат подписанта. Интерфейс
 * подписи — sign.js, вкладки — app.js. Вкладка «Проверить» — отдельный движок
 * public/js/sigcheck/* (ES-модули), с этим файлом он не связан. Криптография
 * целиком живёт в общем наборе public/js/pki/* (cms.js, gost.js, x509.js,
 * pkcs12.js, hash-file.js) — тул её не повторяет.
 *
 * ES2019, без модулей: страница грузит файлы тегами по порядку.
 */
(function (root) {
    'use strict';
    var DS = root.DS = root.DS || {};
    var SLUG = DS.SLUG = 'document-signer';
    var STR = {};

    /* ── строки ─────────────────────────────────────────────────────── */
    DS.setStrings = function (s) { STR = s || {}; };
    // t('key', {n: 3}) → строка с подстановкой :n; нет ключа — сам ключ (видно в QA).
    // Один проход по токенам: замены по очереди резали «:name» подстановкой
    // «:n» («Подпись 1 из 3: 3ame» во всех локалях), а имя файла со «:n»
    // внутри подставлялось бы повторно. Токен — самая длинная буквенная
    // последовательность после двоеточия; чужой токен остаётся как есть.
    DS.t = function (key, params) {
        var s = STR[key];
        if (s == null) return key;
        if (!params) return s;
        return String(s).replace(/:([a-z]+)/gi, function (m, k) {
            return Object.prototype.hasOwnProperty.call(params, k) ? String(params[k]) : m;
        });
    };
    DS.plural = function (n, key) {
        // key_one / key_few / key_many — русская и украинская морфология, остальные берут one/many.
        var loc = (root.__LOCALE || 'en').slice(0, 2), form = 'many';
        var n10 = n % 10, n100 = n % 100;
        if (loc === 'ru' || loc === 'uk') form = n10 === 1 && n100 !== 11 ? 'one' : (n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? 'few' : 'many');
        else if (loc === 'ar') form = n === 1 ? 'one' : (n === 2 ? 'two' : 'many');
        else form = n === 1 ? 'one' : 'many';
        var s = STR[key + '_' + form] || STR[key + '_many'] || STR[key + '_one'] || key;
        return s.split(':n').join(String(n));
    };

    /* ── телеметрия и сообщения ─────────────────────────────────────── */
    DS.ae = function (f, extra) {
        try { if (root.__ae) root.__ae('feature_use', Object.assign({ slug: SLUG, f: f }, extra || {})); } catch (e) { /* telemetry never breaks the tool */ }
    };
    DS.stage = function (s, meta) { try { if (root.__stage) root.__stage(s, meta || {}); } catch (e) { /* noop */ } };
    DS.toast = function (msg, type) { if (root.__toast) root.__toast(msg, type || 'info'); };
    /* `say` — фраза тула про этот сбой: она и становится тостом, а место и
       точный текст ошибки уходят в телеметрию. Своего DS.toast рядом не нужно:
       до 07.10.2026 пять мест звали и то и другое — два тоста на одну ошибку. */
    DS.fail = function (err, ctx, say) {
        try { if (root.__handleError) root.__handleError(err, Object.assign({ slug: SLUG }, ctx || {}), say ? { say: say } : undefined); } catch (e) { /* noop */ }
    };
    DS.complete = function (payload) { try { if (root.__aeToolComplete) root.__aeToolComplete(payload); } catch (e) { /* noop */ } };

    /* ── форматирование ─────────────────────────────────────────────── */
    // Дробь — по языку страницы («1,5 МБ» в ru), а не toFixed с точкой.
    function fmt1(x) {
        try { return new Intl.NumberFormat(root.__intlLocale ? root.__intlLocale() : undefined, { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(x); }
        catch (e) { return x.toFixed(1); }
    }
    DS.fmtSize = function (b) {
        if (b >= 1073741824) return fmt1(b / 1073741824) + ' ' + DS.t('u_gb');
        if (b >= 1048576) return fmt1(b / 1048576) + ' ' + DS.t('u_mb');
        if (b >= 1024) return Math.round(b / 1024) + ' ' + DS.t('u_kb');
        return (b || 0) + ' ' + DS.t('u_b');
    };
    DS.hex = function (bytes, sep) {
        var out = [];
        for (var i = 0; i < bytes.length; i++) out.push((bytes[i] < 16 ? '0' : '') + bytes[i].toString(16));
        return out.join(sep || '');
    };
    // Отпечаток: SHA-256 от SubjectPublicKeyInfo — стандартный, его можно
    // пересчитать openssl-ом. Показываем 16 байт группами по 4 знака.
    DS.fingerprint = function (spki) {
        return crypto.subtle.digest('SHA-256', DS.buf(spki)).then(function (h) {
            return DS.hex(new Uint8Array(h)).slice(0, 32).toUpperCase().replace(/(.{4})(?=.)/g, '$1 ');
        });
    };
    DS.buf = function (u) { u = u instanceof Uint8Array ? u : new Uint8Array(u); return u.buffer.slice(u.byteOffset, u.byteOffset + u.byteLength); };

    /* ── элементы ───────────────────────────────────────────────────── */
    DS.$ = function (id) { return document.getElementById(id); };
    DS.el = function (tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text != null) e.textContent = text;
        return e;
    };
    // Данные человека (имя из сертификата, должность, имя файла) — в <bdi>:
    // в арабском интерфейсе «ООО «Ромашка»» иначе теряет закрывающую кавычку —
    // нейтральный знак в конце латинского/кириллического прогона берёт
    // направление абзаца (справа налево), зеркалится и уезжает в начало.
    // <bdi> изолирует прогон и сам решает его направление; выравнивание
    // карточки не меняется, и в скопированный текст ничего не добавляется.
    DS.dataEl = function (tag, cls, text) {
        var e = DS.el(tag, cls);
        e.appendChild(DS.el('bdi', null, text == null ? '' : String(text)));
        return e;
    };
    DS.setData = function (e, text) {
        if (!e) return;
        e.textContent = '';
        e.appendChild(DS.el('bdi', null, text == null ? '' : String(text)));
    };
    DS.show = function (el, v) { if (el) el.hidden = !v; };
    DS.icon = function (name) {
        var tpl = document.getElementById('dsIcon-' + name);
        if (!tpl) return DS.el('span', 'ds-ico');
        var span = DS.el('span', 'ds-ico');
        span.innerHTML = tpl.innerHTML;       // статичный SVG из блейда, не данные
        span.setAttribute('aria-hidden', 'true');
        return span;
    };
    DS.copy = function (text) {
        if (!text) return;
        try {
            navigator.clipboard.writeText(text).then(function () { DS.toast(DS.t('copied'), 'success'); }, function () {});
        } catch (e) { /* no clipboard */ }
    };
    DS.save = function (blob, name) {
        if (root.__downloadFile) return root.__downloadFile(blob, name);
        var u = URL.createObjectURL(blob), a = document.createElement('a');
        a.href = u; a.download = name; document.body.appendChild(a); a.click();
        setTimeout(function () { a.remove(); URL.revokeObjectURL(u); }, 120000);
        return true;
    };
    // Имя файла: Unicode сохраняется (кириллица — не «_»), чистит только то,
    // что запрещают файловые системы. Одна дверь — output-filename.js.
    DS.safeName = function (name, fallback) {
        var s = String(name || '').trim();
        if (root.__outputName && root.__outputName.sanitize) s = root.__outputName.sanitize(s);
        else s = s.replace(/[\\/:*?"<>|\u0000-\u001f]+/g, ' ').trim();
        return s || fallback || 'document';
    };

    /* ── чтение файла ───────────────────────────────────────────────── */
    DS.readBytes = function (file) { return file.arrayBuffer().then(function (b) { return new Uint8Array(b); }); };
    DS.baseName = function (name) { return String(name || '').replace(/\.[^.]+$/, ''); };

    /* ── хеши ───────────────────────────────────────────────────────── */
    // Хеш файла по OID — общий pki/hash-file.js (большие файлы и ГОСТ — в
    // воркере). onProgress(0..1). Uint8Array или null (алгоритм не знаем).
    DS.hashFile = function (file, oid, onProgress) { return root.PKI.hashFile(file, oid, onProgress); };

    /* ── хранилище ключа (IndexedDB) ────────────────────────────────── */
    /*
     * Раньше ключ лежал открытым JWK в localStorage — его читает любой скрипт
     * страницы как строку. Теперь это CryptoKey в IndexedDB: браузер хранит
     * его сам, строкой он не выгружается. С паролем в базе лежит только
     * зашифрованный PKCS#8 (PBKDF2-SHA-256, 600 000 итераций, AES-GCM).
     * ⚠️ Safari стирает хранилище сайта после 7 дней без визитов — поэтому
     * резервная копия (.p12) предлагается сразу после создания ключа.
     */
    var DB_NAME = 'timbrica-document-signer', STORE = 'keys', REC = 'identity';
    var LEGACY_LS = 'tmb:document-signer:key';
    var PBKDF2_ITER = 600000;
    function idb() {
        return new Promise(function (resolve, reject) {
            if (!root.indexedDB) { reject(new Error('no_idb')); return; }
            var rq = root.indexedDB.open(DB_NAME, 1);
            rq.onupgradeneeded = function () { rq.result.createObjectStore(STORE); };
            rq.onsuccess = function () { resolve(rq.result); };
            rq.onerror = function () { reject(rq.error || new Error('idb')); };
        });
    }
    function idbDo(mode, fn) {
        return idb().then(function (db) {
            return new Promise(function (resolve, reject) {
                var tx = db.transaction(STORE, mode), st = tx.objectStore(STORE), out;
                var rq = fn(st);
                if (rq) rq.onsuccess = function () { out = rq.result; };
                tx.oncomplete = function () { db.close(); resolve(out); };
                tx.onerror = tx.onabort = function () { db.close(); reject(tx.error || new Error('idb_tx')); };
            });
        });
    }
    DS.store = {
        load: function () { return idbDo('readonly', function (st) { return st.get(REC); }).catch(function () { return null; }); },
        save: function (rec) { return idbDo('readwrite', function (st) { return st.put(rec, REC); }); },
        clear: function () { return idbDo('readwrite', function (st) { return st.delete(REC); }).catch(function () {}); },
        legacy: function () {
            try { var r = root.localStorage.getItem(LEGACY_LS); return r ? JSON.parse(r) : null; } catch (e) { return null; }
        },
        dropLegacy: function () { try { root.localStorage.removeItem(LEGACY_LS); } catch (e) { /* noop */ } }
    };

    function b64(u) { var s = ''; for (var i = 0; i < u.length; i++) s += String.fromCharCode(u[i]); return btoa(s); }
    function unb64(s) { var bin = atob(s), o = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) o[i] = bin.charCodeAt(i); return o; }
    DS.b64 = b64; DS.unb64 = unb64;

    function deriveAes(password, salt, iter) {
        return crypto.subtle.importKey('raw', new TextEncoder().encode(password), 'PBKDF2', false, ['deriveKey']).then(function (base) {
            return crypto.subtle.deriveKey({ name: 'PBKDF2', salt: salt, iterations: iter, hash: 'SHA-256' }, base, { name: 'AES-GCM', length: 256 }, false, ['encrypt', 'decrypt']);
        });
    }
    DS.encryptBytes = function (bytes, password) {
        var salt = crypto.getRandomValues(new Uint8Array(16)), iv = crypto.getRandomValues(new Uint8Array(12));
        return deriveAes(password, salt, PBKDF2_ITER).then(function (k) {
            return crypto.subtle.encrypt({ name: 'AES-GCM', iv: iv }, k, DS.buf(bytes));
        }).then(function (ct) {
            return { v: 2, kdf: 'PBKDF2-SHA256', iter: PBKDF2_ITER, salt: b64(salt), iv: b64(iv), ct: b64(new Uint8Array(ct)) };
        });
    };
    DS.decryptBytes = function (enc, password) {
        return deriveAes(password, unb64(enc.salt), enc.iter || 210000).then(function (k) {
            return crypto.subtle.decrypt({ name: 'AES-GCM', iv: unb64(enc.iv) }, k, unb64(enc.ct));
        }).then(function (pt) { return new Uint8Array(pt); });
    };

    /* Импорт закрытого ключа PKCS#8 в WebCrypto: ECDSA (P-256/384) или RSA. */
    DS.importPkcs8 = function (pkcs8) {
        var P = root.PKI, parsed = P.Keys.parsePrivate(pkcs8);
        var kind = parsed.kind;
        if (kind === 'EC') {
            var curve = parsed.webcryptoCurve || (parsed.curve === 'P-384' ? 'P-384' : 'P-256');
            return crypto.subtle.importKey('pkcs8', DS.buf(pkcs8), { name: 'ECDSA', namedCurve: curve }, true, ['sign'])
                .then(function (k) { return { key: k, kind: 'EC', curve: curve }; });
        }
        if (kind === 'RSA') {
            return crypto.subtle.importKey('pkcs8', DS.buf(pkcs8), { name: 'RSASSA-PKCS1-v1_5', hash: 'SHA-256' }, true, ['sign'])
                .then(function (k) { return { key: k, kind: 'RSA' }; });
        }
        return Promise.reject(new Error('unsupported_key:' + kind));
    };

    /* Самоподписанный сертификат подписанта: тот же ключ → тот же отпечаток,
       имя и почта — поля сертификата. Переиздаётся при смене имени. */
    DS.buildIdentityCert = function (keyPair, identity) {
        var X509 = root.PKI.X509;
        return crypto.subtle.exportKey('spki', keyPair.publicKey).then(function (spkiBuf) {
            var spki = new Uint8Array(spkiBuf);
            return X509.subjectKeyIdFor(spki).then(function (ski) {
                var subject = [{ short: 'CN', value: identity.name || DS.t('signer_default_name') }];
                if (identity.org) subject.push({ short: 'O', value: identity.org });
                if (identity.email) subject.push({ short: 'emailAddress', value: identity.email });
                var now = new Date(Date.now() - 5 * 60000);
                var later = new Date(now.getTime() + 10 * 365.25 * 86400000);
                return X509.build({
                    signerKind: 'EC', signerKey: keyPair.privateKey, hash: 'SHA-256',
                    issuer: subject, subject: subject, notBefore: now, notAfter: later,
                    publicKeySpki: spki,
                    extensions: {
                        keyUsage: ['digitalSignature', 'nonRepudiation'],
                        // RFC 9336 documentSigning + S/MIME + Microsoft Document Signing:
                        // так ключ «про подпись документов» для openssl, Windows и Office.
                        extKeyUsage: ['1.3.6.1.5.5.7.3.36', '1.3.6.1.5.5.7.3.4', '1.3.6.1.4.1.311.10.3.12'],
                        subjectKeyId: ski
                    }
                }).then(function (der) { return { der: der, spki: spki }; });
            });
        });
    };

})(typeof window !== 'undefined' ? window : globalThis);
